module.exports = __webpack_public_path__ + "static/media/tutorial.220b596a.mp4";